/* LZ Flowers Shopify theme: bag drawer, add-ons, filters, hero video. No dependencies. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var drawer = $("#drawer"), scrim = $("#scrim");
  if (!drawer) return;

  var ROOT = drawer.dataset.root || "/";
  var CART_URL = drawer.dataset.cartUrl || "/cart";
  var CURRENCY = drawer.dataset.currency || "USD";
  var cart = null;

  var fmt;
  try { fmt = new Intl.NumberFormat(undefined, { style: "currency", currency: CURRENCY }); } catch (e) { fmt = null; }
  var money = function (cents) {
    var v = cents / 100;
    if (!fmt) return "$" + (Math.round(v) === v ? v : v.toFixed(2));
    var s = fmt.format(v);
    return Math.round(v) === v ? s.replace(/\.00$/, "") : s;
  };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };

  /* ---------- toast ---------- */
  var tt;
  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove("show"); }, 3200);
  }

  /* ---------- cart api ---------- */
  function api(path, body) {
    return fetch(ROOT.replace(/\/$/, "") + path, {
      method: body ? "POST" : "GET",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: body ? JSON.stringify(body) : undefined,
      credentials: "same-origin"
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || "Something went wrong"); e.data = j; throw e; }
        return j;
      });
    });
  }
  function refresh() {
    return api("/cart.js").then(function (c) { cart = c; render(); return c; });
  }
  function prop(item, name) { return item.properties && item.properties[name]; }
  function isAddon(item) { return prop(item, "_addon") === "true"; }
  function groupOf(item) { return prop(item, "_group"); }

  /* ---------- drawer ---------- */
  function render() {
    if (!cart) return;
    var n = cart.items.filter(function (i) { return !isAddon(i); }).reduce(function (a, i) { return a + i.quantity; }, 0);
    var count = $("#bagCount"); if (count) count.textContent = n;
    var total = $("#bagTotal"); if (total) total.textContent = money(cart.total_price);
    var btn = $("#checkoutBtn");
    if (btn) { btn.setAttribute("aria-disabled", n ? "false" : "true"); btn.setAttribute("href", CART_URL); }
    var body = $("#bagItems");
    if (!cart.items.length) {
      body.innerHTML = '<div class="bag-empty"><p class="script">Your bag is empty</p><p>Choose a bouquet by stem count to begin.</p></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var addon = isAddon(it);
      var lines = [];
      Object.keys(it.properties || {}).forEach(function (k) {
        if (k.charAt(0) === "_" || !it.properties[k] || k === "For" || k === "Add-ons") return;
        lines.push(esc(k) + ": " + (k === "Ribbon message" || k === "Banner message" || k === "Message" ? "<q>" + esc(it.properties[k]) + "</q>" : esc(it.properties[k])));
      });
      var pz = lines.length ? '<p class="pz">' + lines.join("<br>") + "</p>" : "";
      var variant = it.variant_title && it.variant_title !== "Default Title" ? '<p class="pz">' + esc(it.variant_title) + "</p>" : "";
      var img = !addon && it.image ? '<a href="' + esc(it.url) + '"><img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '" width="76" height="95" loading="lazy"></a>' : "<span></span>";
      return '<div class="line' + (addon ? " is-addon" : "") + '">' + img + "<div>" +
        (addon ? '<span class="addon-tag">Add-on</span>' : "") + '<h3><a href="' + esc(it.url) + '">' + esc(it.product_title) + "</a></h3>" + variant + pz +
        '<div class="line-row"><div class="qty"><button type="button" data-dq="-1" data-key="' + esc(it.key) + '" aria-label="Decrease">−</button><span>' + it.quantity +
        '</span><button type="button" data-dq="1" data-key="' + esc(it.key) + '" aria-label="Increase">+</button></div><strong>' + money(it.final_line_price) + "</strong></div>" +
        '<button class="rm" type="button" data-rm="' + esc(it.key) + '">Remove</button></div></div>';
    }).join("");
  }

  function open() { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); if (scrim) scrim.hidden = false; }
  function close() { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); if (scrim) scrim.hidden = true; }
  window.LZ = { openBag: open, refreshCart: refresh };

  function byKey(key) { return cart.items.filter(function (i) { return i.key === key; })[0]; }
  function groupItems(item) {
    var g = groupOf(item);
    if (!g) return [item];
    return cart.items.filter(function (i) { return groupOf(i) === g; });
  }
  function updates(map) {
    return api("/cart/update.js", { updates: map }).then(function (c) { cart = c; render(); }).catch(function (e) { toast(e.message); return refresh(); });
  }

  $("#bagBtn") && $("#bagBtn").addEventListener("click", function () { refresh().then(open); });
  $("#closeBag") && $("#closeBag").addEventListener("click", close);
  scrim && scrim.addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  $("#checkoutBtn").addEventListener("click", function (e) {
    if (this.getAttribute("aria-disabled") === "true") { e.preventDefault(); }
  });

  $("#bagItems").addEventListener("click", function (e) {
    var t = e.target;
    if (t.dataset.dq) {
      var it = byKey(t.dataset.key); if (!it) return;
      var next = Math.max(0, it.quantity + +t.dataset.dq), map = {};
      if (!isAddon(it) && groupOf(it)) {
        groupItems(it).forEach(function (g) {
          map[g.key] = g.key === it.key ? next : Math.round((g.quantity / it.quantity) * next);
        });
      } else { map[it.key] = next; }
      updates(map);
    }
    if (t.dataset.rm) {
      var r = byKey(t.dataset.rm); if (!r) return;
      var rm = {};
      (isAddon(r) ? [r] : groupItems(r)).forEach(function (g) { rm[g.key] = 0; });
      updates(rm);
    }
  });

  /* ---------- add to bag ---------- */
  function addItems(items) {
    return api("/cart/add.js", { items: items }).then(refresh);
  }

  // quick add from cards (bouquet only)
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-add-quick]"); if (!b) return;
    b.disabled = true;
    addItems([{ id: +b.dataset.variantId, quantity: 1 }]).then(function () {
      toast(b.dataset.name + " added to your bag"); open();
    }).catch(function (err) { toast(err.message); }).then(function () { b.disabled = false; });
  });

  // mobile menu
  var mb = $("#menuBtn"), nav = $("#nav");
  if (mb && nav) {
    mb.addEventListener("click", function () { var o = nav.classList.toggle("is-open"); mb.setAttribute("aria-expanded", o); });
    $$("#nav a").forEach(function (a) { a.addEventListener("click", function () { nav.classList.remove("is-open"); mb.setAttribute("aria-expanded", "false"); }); });
  }

  /* ---------- collection filters + sort ---------- */
  var grid = $("#grid");
  if (grid) {
    var cards = $$(".card", grid), filter = "all";
    cards.forEach(function (c, i) { c.dataset.i = i; });
    var apply = function () {
      var shown = 0;
      cards.forEach(function (c) { var ok = filter === "all" || c.dataset.color === filter; c.hidden = !ok; if (ok) shown++; });
      var empty = $("#empty"); if (empty) empty.hidden = !!shown;
    };
    $$(".chip").forEach(function (ch) {
      ch.addEventListener("click", function () {
        filter = ch.dataset.filter;
        $$(".chip").forEach(function (x) { var on = x === ch; x.classList.toggle("is-on", on); x.setAttribute("aria-pressed", on); });
        apply();
      });
    });
    var sel = $("#sortSel");
    if (sel) sel.addEventListener("change", function () {
      var v = this.value;
      cards.slice().sort(function (a, b) {
        if (v === "asc") return a.dataset.price - b.dataset.price;
        if (v === "desc") return b.dataset.price - a.dataset.price;
        return a.dataset.i - b.dataset.i;
      }).forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ---------- product page ---------- */
  var section = $("[data-product-section]");
  var form = $("#pdForm");
  if (section && form) {
    var qty = $("#qty"), addTotal = $("#addTotal"), priceEl = $("#pdPrice");
    var basePrice = +section.dataset.basePrice || 0;
    var variantSel = $("[data-variant-select]", form);
    var addons = $$("[data-addon]", form);

    var getQty = function () { return Math.max(1, Math.min(20, +qty.value || 1)); };
    var currentBase = function () {
      if (variantSel) { var o = variantSel.options[variantSel.selectedIndex]; return +o.dataset.price || basePrice; }
      return basePrice;
    };
    // chosen add-ons: [{id, title, price, perBouquet, kind, text}]
    var chosen = function () {
      var out = [];
      addons.forEach(function (a) {
        var kind = a.dataset.kind, per = 0, text = "";
        if (kind === "check") per = a.checked ? 1 : 0;
        else if (kind === "unit") per = Math.max(0, Math.min(+a.max || 50, parseInt(a.value, 10) || 0));
        else if (kind === "text") { text = a.value.trim(); per = text ? 1 : 0; }
        if (per > 0) out.push({ id: +a.dataset.variantId, title: a.dataset.title, price: +a.dataset.price, per: per, kind: kind, text: text });
      });
      return out;
    };
    var updateTotal = function () {
      var q = getQty(), base = currentBase();
      var extra = chosen().reduce(function (s, a) { return s + a.price * a.per; }, 0);
      if (addTotal) addTotal.textContent = money((base + extra) * q);
      if (priceEl) priceEl.textContent = money(base);
    };
    $$("[data-q]", form).forEach(function (b) { b.addEventListener("click", function () { qty.value = Math.max(1, Math.min(20, getQty() + +b.dataset.q)); updateTotal(); }); });
    form.addEventListener("input", updateTotal);
    form.addEventListener("change", updateTotal);
    updateTotal();

    var submitItems = function () {
      var q = getQty(), extra = chosen();
      var id = variantSel ? +variantSel.value : +$("[name=id]", form).value;
      var title = ($(".pd-t") || {}).textContent || "";
      if (!extra.length) return [{ id: id, quantity: q }];
      var group = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var summary = extra.filter(function (a) { return a.kind !== "text"; }).map(function (a) { return a.kind === "unit" ? a.title + " ×" + a.per : a.title; });
      var banner = extra.filter(function (a) { return a.kind === "text"; })[0];
      var props = { "_group": group };
      if (banner) props["Ribbon message"] = banner.text;
      if (summary.length) props["Add-ons"] = summary.join(", ");
      var items = [{ id: id, quantity: q, properties: props }];
      extra.forEach(function (a) {
        var p = { "_addon": "true", "_group": group, "For": title };
        if (a.kind === "text") p["Message"] = a.text;
        items.push({ id: a.id, quantity: a.per * q, properties: p });
      });
      return items;
    };

    var busy = false;
    var go = function (checkout) {
      if (busy) return; busy = true;
      addItems(submitItems()).then(function () {
        if (checkout) { window.location.href = ROOT.replace(/\/$/, "") + "/checkout"; return; }
        toast("Added to your bag"); open();
      }).catch(function (err) { toast(err.message); }).then(function () { busy = false; });
    };
    form.addEventListener("submit", function (e) { e.preventDefault(); go(false); });
    var buy = $("#buyNow"); if (buy) buy.addEventListener("click", function () { go(true); });

    $$(".pd-thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        var main = $("#pdMain"); if (main) { main.src = t.dataset.src; main.removeAttribute("srcset"); }
        $$(".pd-thumb").forEach(function (x) { x.classList.toggle("is-on", x === t); });
      });
    });
  }

  /* ---------- hero video ---------- */
  var hv = $("#heroVideo"), vt = $("#vidToggle");
  if (hv) {
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var userPaused = reduce;
    var setBtn = function () { if (vt) { vt.setAttribute("aria-pressed", String(hv.paused)); vt.setAttribute("aria-label", hv.paused ? "Play background video" : "Pause background video"); } };
    if (reduce) { hv.removeAttribute("autoplay"); hv.pause(); }
    else { var pr = hv.play(); if (pr && pr.catch) pr.catch(function () {}); }
    if (vt) vt.addEventListener("click", function () { if (hv.paused) { userPaused = false; hv.play(); } else { userPaused = true; hv.pause(); } setBtn(); });
    hv.addEventListener("play", setBtn); hv.addEventListener("pause", setBtn);
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (userPaused) return; if (e.isIntersecting) { var p = hv.play(); if (p && p.catch) p.catch(function () {}); } else hv.pause(); });
    }).observe(hv);
  }

  refresh();
})();
